import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  boldStyle: {
    fontFamily: 'MANEurope, Arial, sans-serif',
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 'bold',
    color: '#303c49',
    lineHeight: 0.91
  },
  normalStyle: {
    fontFamily: 'MAN-light, Arial, sans-serif',
    fontSize: theme.typography.pxToRem(22),
    fontWeight: '300',
    color: '#303a44',
    lineHeight: 1.09
  }
})

const Heading3 = ({
  classes: { boldStyle, normalStyle },
  className,
  component,
  bold,
  children,
  ...otherProps
}) => {
  const headingClass = classNames(
    bold ? boldStyle : normalStyle,
    className
  )
  return (
    <Typography
      component={component || 'h3'}
      className={headingClass}
      {...otherProps}
    >
      {children}
    </Typography>
  )
}

Heading3.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array
  ]),
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  bold: PropTypes.bool,
  children: PropTypes.node
}

export default withStyles(styles)(Heading3)



// WEBPACK FOOTER //
// ./src/styleguide/Heading3.js